import FaqService from '@/apis/faq';
import {Vue, Component, Inject} from 'vue-property-decorator';

@Component({

})

export default class questionsComponents extends Vue {
    @Inject('faqService') private faqService!: () => FaqService;

	public faqs: any[] = [];
    private FIRST_ITEM_QUANTITY: number = 6;
    public isShowMore: boolean = false;
    
    public get firstFaqs() : any[] {
        return this.faqs.slice(0, this.FIRST_ITEM_QUANTITY);
    }

    public get otherFaqs() : any[] {
        return this.faqs.slice(this.FIRST_ITEM_QUANTITY, this.faqs.length);
    }
    

	async mounted() {
        const faqResponse = await this.faqService().getFAQ();
        this.faqs = faqResponse.Faqs;
    }
}
